export default __webpack_public_path__ + "images/15fc54b73924a42981e66122ae9dbfbb.png";